<template>
    <div>
        <limitless-page-header title="Momsrapport" sub-title="Inlösen"></limitless-page-header>

        <div class="content">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="d-flex">
                                <div class="col-form-label" style="width: 100px;">Period</div>
                                <div style="width: 150px;">
                                    <v-select
                                        :options="years"
                                        v-model="filter.from_year"
                                        :clearable="false"
                                    ></v-select>
                                </div>
                                <div style="width: 100px;">
                                    <v-select
                                        :options="months"
                                        v-model="filter.from_month"
                                        :clearable="false"
                                    ></v-select>
                                </div>
                            </div>
<!--                            <div class="d-flex">-->
<!--                                <div class="col-form-label" style="width: 100px;">Till</div>-->
<!--                                <div style="width: 150px;">-->
<!--                                    <v-select-->
<!--                                        :options="years"-->
<!--                                        v-model="filter.to_year"-->
<!--                                        :clearable="false"-->
<!--                                    ></v-select>-->
<!--                                </div>-->
<!--                                <div style="width: 100px;">-->
<!--                                    <v-select-->
<!--                                        :options="months"-->
<!--                                        v-model="filter.to_month"-->
<!--                                        :clearable="false"-->
<!--                                    ></v-select>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="mt-2">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" class="custom-control-input" id="chk-moms" v-model="filter.only_eu_export" :value="0">
                                    <label class="custom-control-label" for="chk-moms">Visa Sverige, EU privatperson</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" class="custom-control-input" id="chk-ejmoms" v-model="filter.only_eu_export" :value="1">
                                    <label class="custom-control-label" for="chk-ejmoms">Visa EU Företag & Export (Ej moms)</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 text-right">
                            <limitless-button btn-class="btn-light" @click="exportExcel" icon="icon-file-excel">Exportera Excel</limitless-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="table-responsive mb-0">
                    <table v-if="this.tabledata && Object.keys(this.tabledata).length > 0" class="table table-bordered table-xs">
                        <tbody>
                        <template v-for="(yearData, year) in tabledata">
                            <tr :key="'tr-1-' + year">
                                <th colspan="9" style="background-color: #ae2d3e; color: #ffffff;">Sålda {{ year }}</th>
                            </tr>
                            <tr :key="'tr-2-' + year">
                                <th>Serie</th>
                                <th>Benämning</th>
                                <th class="text-right">Antal kort</th>
                                <th class="text-right">Snittpris</th>
                                <th class="text-right">Totalt</th>
                                <th class="text-right">Momssats</th>
                                <th class="text-right">Moms</th>
                                <th class="text-right">Summa</th>
                                <th></th>
                            </tr>
                            <tr v-for="row in yearData.rows" :key="'tr-' + year + '-r-' + row.CardSeriesID + '-' + row.VAT">
                                <td>
                                    <router-link :to="'/economy/report/vat-redeem/cards/' + row.CardSeriesID + '/' + filter.from_year + '-' + filter.from_month">
                                        {{ row.CardSeriesID }}
                                    </router-link>
                                </td>
                                <td>{{ row.SeriesName }}</td>
                                <td class="text-right">{{ formatNumber(row.quantity, 1) }} st</td>
                                <td class="text-right">{{ formatCurrency(row.average_price) }}</td>
                                <td class="text-right">{{ formatCurrency(row.total_price) }}</td>
                                <td class="text-right">{{ row.VAT }}</td>
                                <td class="text-right">{{ formatCurrency(row.total_vat) }}</td>
                                <td class="text-right">{{ formatCurrency(row.sum) }}</td>
                                <td></td>
                            </tr>
                            <tr v-if="yearData.totals.vat_25" :key="'tr-v25-' + year">
                                <th colspan="2">Moms 25%</th>
                                <th class="text-right">{{ formatNumber(yearData.totals.vat_25.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_25.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_25.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_25.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr v-if="yearData.totals.vat_12" :key="'tr-v12-' + year">
                                <th colspan="2">Moms 12%</th>
                                <th class="text-right">{{ formatNumber(yearData.totals.vat_12.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_12.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_12.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_12.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr v-if="yearData.totals.vat_6" :key="'tr-v6-' + year">
                                <th colspan="2">Moms 6%</th>
                                <th class="text-right">{{ formatNumber(yearData.totals.vat_6.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_6.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_6.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.vat_6.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr :key="'tr-tot-' + year">
                                <th colspan="2">Summering {{ year }}</th>
                                <th class="text-right">{{ formatNumber(yearData.totals.total.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.total.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.total.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(yearData.totals.total.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr :key="'tr-space-' + year">
                                <th colspan="9"></th>
                            </tr>
                        </template>
                        </tbody>
                        <tfoot v-if="totals.total.quantity > 0" style="background: #f5f5f5;">
                            <tr>
                                <th colspan="9" style="background-color: #ae2d3e; color: #ffffff;"></th>
                            </tr>
                            <tr>
                                <th colspan="2">Totalsummering</th>
                                <th class="text-right">{{ formatNumber(totals.total.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.total.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.total.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(totals.total.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr v-if="totals.vat_25.quantity > 0">
                                <th colspan="2">Moms 25%</th>
                                <th class="text-right">{{ formatNumber(totals.vat_25.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.vat_25.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.vat_25.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(totals.vat_25.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr v-if="totals.vat_12.quantity > 0">
                                <th colspan="2">Moms 12%</th>
                                <th class="text-right">{{ formatNumber(totals.vat_12.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.vat_12.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.vat_12.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(totals.vat_12.sum) }}</th>
                                <th></th>
                            </tr>
                            <tr v-if="totals.vat_6.quantity > 0">
                                <th colspan="2">Moms 6%</th>
                                <th class="text-right">{{ formatNumber(totals.vat_6.quantity, 1) }} st</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.vat_6.total_price) }}</th>
                                <th></th>
                                <th class="text-right">{{ formatCurrency(totals.vat_6.total_vat) }}</th>
                                <th class="text-right">{{ formatCurrency(totals.vat_6.sum) }}</th>
                                <th></th>
                            </tr>
                        </tfoot>
<!--                        <tfoot>-->
<!--                            <tr>-->
<!--                                <th colspan="2">Totalt:</th>-->
<!--                                <th-->
<!--                                    v-for="account in accounts"-->
<!--                                    :key="'tf-' + account.number"-->
<!--                                    class="text-right"-->
<!--                                >-->
<!--                                    {{ formatNumber(invoices.totals[account.number] ? invoices.totals[account.number] : 0) }}-->
<!--                                </th>-->
<!--                                <th colspan="4"></th>-->
<!--                            </tr>-->
<!--                        </tfoot>-->
                    </table>
                    <div v-else class="card-body"><i>Ingen data för val period...</i></div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import apiClient from '@services/ApiClient';
import vSelect from 'vue-select';
import { formatCurrency, formatNumber } from '@services/Helpers';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import { debounce } from 'lodash';
import BackendRepository from '@services/repositories/BackendRepository';

export default {
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        vSelect,
    },
    data: () => ({
        loading: true,
        tabledata: null,
        accounts: [],
        filter: {
            from_year: null,
            from_month: null,
            to_year: null,
            to_month: null,
            only_eu_export: 0,
        },
    }),
    mounted() {
        this.getAccounts();
        const today = new Date();
        this.filter.from_year = today.getFullYear();
        this.filter.from_month = `${today.getMonth() + 1}`.padStart(2, '0');
        // this.filter.to_year = today.getFullYear();
        // this.filter.to_month = `${today.getMonth() + 1}`.padStart(2, '0');
        this.getData();
    },
    watch: {
        filter: {
            deep: true,
            handler: debounce(function filterHandler() {
                const vm = this;
                vm.getData();
            }),
        },
    },
    methods: {
        formatCurrency,
        formatNumber,
        getData() {
            this.loading = true;
            apiClient.get('/vue/economy/report/vatredeem', { params: this.filter })
                .then((response) => {
                    this.tabledata = response.data;
                })
                .finally(() => {
                    this.loading = true;
                });
        },
        exportExcel() {
            const filter = { ...this.filter };
            Object.keys(filter).forEach((key) => {
                if (filter[key] === null) {
                    filter[key] = '';
                }
            });
            window.open('/economy/report/vat-redeem/excel?' + new URLSearchParams(filter).toString());
        },
        getAccounts() {
            BackendRepository.getAccounts().then((res) => {
                this.accounts = res;
            });
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
        years() {
            const today = new Date();
            const arr = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 2020; i <= today.getFullYear(); i++) {
                arr.push(i);
            }
            return arr;
        },
        months() {
            const arr = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 1; i <= 12; i++) {
                arr.push(`${i}`.padStart(2, '0'));
            }
            return arr;
        },
        totals() {
            const obj = {
                total: {
                    quantity: 0,
                    total_price: 0,
                    total_vat: 0,
                    sum: 0,
                },
                vat_25: {
                    quantity: 0,
                    total_price: 0,
                    total_vat: 0,
                    sum: 0,
                },
                vat_12: {
                    quantity: 0,
                    total_price: 0,
                    total_vat: 0,
                    sum: 0,
                },
                vat_6: {
                    quantity: 0,
                    total_price: 0,
                    total_vat: 0,
                    sum: 0,
                },
            };

            if (this.tabledata) {
                if (Object.keys(this.tabledata).length > 0) {
                    Object.values(this.tabledata).forEach((yearData) => {
                        Object.entries(yearData.totals).forEach(([key, value]) => {
                            if (obj[key]) {
                                obj[key].quantity += value.quantity;
                                obj[key].total_price += value.total_price;
                                obj[key].total_vat += value.total_vat;
                                obj[key].sum += value.sum;
                            }
                        });
                    });
                }
            }

            return obj;
        },
    },
};

</script>
